import React from 'react';
import { useIntl } from 'react-intl';
import Search, { SearchEvent } from 'carbon-react/lib/components/search';
import { Box } from 'carbon-react/lib/components/box/box.component';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';

import * as styles from './drivers-toolbar.scss';

interface Props {
  searchText: string;
  onSearchChange: (event: SearchEvent) => void;
  onReorderClick: () => void;
  onCreateGroupClick: () => void;
  isReordering?: boolean;
  isUpdating: boolean;
  onSaveReorder: () => void;
  onCancelReorder: () => void;
}

export const DriversToolbar = ({
  searchText,
  onSearchChange,
  onReorderClick,
  onCreateGroupClick,
  isReordering,
  isUpdating,
  onSaveReorder,
  onCancelReorder
}: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <Box className={styles.searchInput} flexShrink={0}>
        <Search
          id="search-drivers"
          label={intl.formatMessage({
            id: 'common.search_ellipsis',
            defaultMessage: 'Search...'
          })}
          onChange={onSearchChange}
          value={searchText}
          inputWidth={100}
          searchButton
        />
      </Box>
      <Box alignSelf="stretch" mx="16px" backgroundColor="#CCD6DB" width="1px" />
      <Box display="flex" flexShrink={0}>
        {isReordering ? (
          <>
            <Button buttonType="primary" mr={1} onClick={onSaveReorder} disabled={isUpdating}>
              <FormattedMessage id="predict.save_new_order" defaultMessage="Save new order" />
            </Button>
            <Button buttonType="secondary" onClick={onCancelReorder} disabled={isUpdating}>
              <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
            </Button>
          </>
        ) : (
          <>
            <Button buttonType="secondary" mr={1} onClick={onReorderClick} disabled={isUpdating}>
              <FormattedMessage id="common.reorder" defaultMessage="Reorder" />
            </Button>
            <Button buttonType="secondary" onClick={onCreateGroupClick} disabled={isUpdating}>
              <FormattedMessage id="common.create_group" defaultMessage="Create group" />
            </Button>
          </>
        )}
      </Box>
    </div>
  );
};
